export default "__VITE_ASSET__PSn0mZkv__"